export default __webpack_public_path__ + "static/media/EM1480.34I-38128_-26493_0.3d18c65c.jpg";